// lib/filters/ParseUnixTime

import parseUnixTime from 'lib/parseUnixTime'

export default {filters: {parseTime: parseUnixTime} }



/** WEBPACK FOOTER **
 ** ./src/js/lib/filters/parseUnixTime.js
 **/